var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-content" },
    [
      _c(
        "div",
        { staticClass: "tomooni_wrap" },
        [
          _c("svg-icon", {
            staticClass: "tomooni",
            attrs: { "icon-class": "tomooni_works" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "l-inner" }, [
        _vm._m(0),
        _c("div", { staticClass: "error-message-box" }, [
          _vm._m(1),
          _c("div", { staticClass: "error-message-cnt-box" }, [
            _c(
              "div",
              {
                staticClass: "error-message-link-box",
                on: { click: _vm.goLogin },
              },
              [
                _c("a", { staticClass: "sbmt-btn is-main" }, [
                  _vm._v("ログイン"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _c("vab-main-footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cnt-ttl-wrap" }, [
      _c("h2", { staticClass: "cnt-ttl--l" }, [
        _c("span", { staticClass: "cnt-ttl-txt" }, [_vm._v("ログアウト")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "error-message-ttl-box" }, [
      _c("h3", { staticClass: "error-message-ttl" }, [
        _vm._v("ログアウトが完了しました"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }